import './index.scss';
import React, { useEffect, useState } from 'react';
import Utils from '../../CourseApp/Helper/utils';

import { Editor } from "@tinymce/tinymce-react";

function TinyMCEControl({ structure, saveValue, defaultValue, runtimeValue }) {
    const [controlValue, setControlValue] = useState(defaultValue ?? '');
    const [placeholder, setPlaceholder] = useState(defaultValue ?? '');
    const sizeLimit = structure.rules.maxChar;

    const tinymceScriptLocation = process.env.NODE_ENV === "development" ? "/tinymce/tinymce.min.js" : "/application/tribelio/default/media/js/tb/tbcourse/public/tinymce/tinymce.min.js"

    const handleChange = (content, editor) => {
        let text = editor.getContent({ format: "text" });
        const length = text.length;
        if (sizeLimit > 0) {
            if (length <= sizeLimit) {
                setControlValue(content);
                saveValue(content);
            }
            if (editor.execCommand('Paste') && length > sizeLimit) {
                // let replacetext = text.substring(0, sizeLimit).replace(/\w+$/, '');
                let replacetext = text.slice(0, sizeLimit);
                setControlValue(`<p>${replacetext}</p>`);
                saveValue(`<p>${replacetext}</p>`)
                Utils.showError(`max ${sizeLimit} characters`, true, 'maxLength');
            }
        } else {
            setControlValue(content);
            saveValue(content);
        }
    }

    const handleBeforeAddUndo = (evt, editor) => {
        const length = editor.getContent({ format: "text" }).length;
        if (length > sizeLimit) {
            evt.preventDefault();
        }
    };

    useEffect(() => {
        if (typeof defaultValue !== 'undefined') {
            setControlValue(defaultValue);
        } else {
            setControlValue('');
        }

        setPlaceholder(structure.placeholder);
    }, [defaultValue, structure.placeholder]);

    return (
        <div className="tbcourse-editor-control-tinymce">
            <div className="tinymce-container">
                {placeholder === structure.placeholder && (< Editor
                    value={runtimeValue ?? controlValue}
                    onEditorChange={handleChange}
                    onBeforeAddUndo={handleBeforeAddUndo}
                    // apiKey='tpe0isrfbvgmc18az8lkxloe3pmn4sd3vfn0bjjllozp6ku6'
                    tinymceScriptSrc={tinymceScriptLocation}
                    init={{
                        height: 200,
                        menubar: false,
                        plugins: [
                            'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                            'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                            'insertdatetime', 'media', 'table'
                        ],
                        paste_as_text: true,
                        toolbar2: "bold italic underline bullist alignleft aligncenter link",
                        content_style: "body { font-family:'Inter', sans-serif; font-size:13px } h1, h2, h3, h4, h5, h6 { font-weight: normal;margin:0px}",
                        branding: false,
                        cache_suffix: "?v=1",
                        lineheight_formats: "8px 9px 10px 11px 12px 14px 16px 18px 20px 22px 24px 26px 36px",
                        placeholder: placeholder,
                        allow_script_urls: true,
                        relative_urls: false,
                        link_assume_external_targets: true,
                        convert_urls: false
                    }}
                />)}
            </div>
        </div>
    );
}

export default TinyMCEControl;
